import React from 'react';
import { motion } from 'framer-motion';
import { Timer } from 'lucide-react';

interface WorkoutTimerProps {
  timeLeft: number;
  totalTime: number;
  isPaused: boolean;
  minimal?: boolean;
}

export function WorkoutTimer({ timeLeft, totalTime, isPaused, minimal = false }: WorkoutTimerProps) {
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  if (minimal) {
    return <span className="font-mono">{formatTime(timeLeft)}</span>;
  }

  const progress = (timeLeft / totalTime) * 100;

  return (
    <div className="relative flex flex-col items-center justify-center">
      {/* Progress Ring */}
      <div className="relative w-24 h-24">
        <svg className="w-full h-full transform -rotate-90">
          {/* Background circle */}
          <circle
            cx="48"
            cy="48"
            r="44"
            className="stroke-muted"
            strokeWidth="4"
            fill="none"
          />
          {/* Progress circle */}
          <motion.circle
            cx="48"
            cy="48"
            r="44"
            className="stroke-primary"
            strokeWidth="4"
            fill="none"
            strokeDasharray={276.46} // 2 * π * r
            initial={{ strokeDashoffset: 276.46 }}
            animate={{ strokeDashoffset: 276.46 * (1 - progress / 100) }}
            transition={{ duration: 0.5 }}
          />
        </svg>

        {/* Timer Display */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-xl font-bold font-mono">{formatTime(timeLeft)}</div>
          <div className="text-xs text-muted-foreground mt-0.5">
            {isPaused ? 'Paused' : 'Remaining'}
          </div>
        </div>
      </div>
    </div>
  );
}